export default class Overlay {

  constructor ($el) {
    this.$el = $el;
    this.open = false;
    this.openClass = 'overlay--visible';

    // collect items
    this.$closeButtons = $el.querySelectorAll('.overlay__close');

    // bind button events
    for (let i = 0; i < this.$closeButtons.length; i++) {
      this.$closeButtons[i].addEventListener('click', this.handleCloseClick.bind(this));
    }

    // Init the overlay
    this.initOverlay();
  }

  initOverlay () {
    if (this.$el.getAttribute('data-visible') === 'true') {
      this.toggleOverlay();
    }
  }

  toggleOverlay () {
    this.$el.classList.toggle(this.openClass);

    this.open = !this.open;
    this.$el.setAttribute('data-visible', this.open.toString()); // Set the correct data-visible label
    this.$el.setAttribute('aria-hidden', !this.open.toString()); // Set the correct aria label
  }

  handleCloseClick (evt) {
    evt.preventDefault();
    this.toggleOverlay();
  }
}
